import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import type { FaqEntry } from '../../types/content';
interface FaqItemProps {
  faq: FaqEntry;
  open: boolean;
  onToggle: () => void;
}
export function FaqItem({
  faq,
  open,
  onToggle
}: FaqItemProps) {
  const reduce = useReducedMotion();
  const buttonId = `faq-btn-${faq.id}`;
  const panelId = `faq-panel-${faq.id}`;
  return <div className="border-t border-line" data-id="element-62" data-mp="2j254j6suurng">
      <h3 data-id="element-63" data-mp="2o3uhirzn1fe6">
        <button id={buttonId} type="button" aria-expanded={open} aria-controls={panelId} onClick={onToggle} className="flex w-full items-center justify-between gap-6 py-5 text-left text-[1.075rem] font-semibold transition-colors duration-150 hover:text-brand sm:text-lg" data-id="element-64" data-mp="2o29nr4l5e0hd">
          {faq.question}
          <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-[transform,background-color,border-color,color] duration-200 ease-out ${open ? 'rotate-45 border-ink bg-ink text-white' : 'border-line text-ink'}`} aria-hidden="true" data-id="element-65" data-mp="13nhdex1p1zw9">
            <PlusIcon className="h-4 w-4" data-id="element-66" data-mp="2xfgps8daxvnw" />
          </span>
        </button>
      </h3>
      <AnimatePresence initial={false} data-id="element-67" data-mp="2sfch34imy588">
        {open && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={reduce ? false : {
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-68" data-mp="36fdkaqmdhoqv">
            <p className="text-pretty max-w-[42rem] pb-6 pr-12 text-[15px] leading-relaxed text-muted sm:text-base" data-id="element-69" data-mp="3p5d694mx2nq2">{faq.answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}